//@flow
import React from 'react';

import {makeStyles, TableCell} from '@material-ui/core';
import CustomTextField from '../../../../../elements/CustomTextField/CustomTextField';
import {useProductContext} from '../../../context';
import {useEditProduct} from '../../../utils/editProduct';
import {debounce} from '../../../../../utils/functions';

const useStyles = makeStyles(theme => ({
  textField: {
    width: '96px',
  },
}));

export default function ProductSkuCell() {
  const classes = useStyles();
  const [product, setProduct] = useProductContext(product => ({
    id: product.id,
    sku: product.sku,
  }));
  const {editProduct} = useEditProduct(product ? product.id : '');

  if (!product) return null;

  const handleChange = debounce(sku => {
    if (!sku) return;

    editProduct({sku});
    setProduct({sku});
  }, 750);

  return (
    <TableCell align="right">
      <CustomTextField
        name="sku"
        className={classes.textField}
        defaultValue={product.sku}
        type="text"
        onChange={e => {
          handleChange(e.target.value);
        }}
      />
    </TableCell>
  );
}
